import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import pageHero from "../assets/banner2.png";
import banner1 from "../assets/banner1.png";
import banner3 from "../assets/banner3.png";
import CallToAction from "./callToAction";
import {
  FaBolt,
  FaBuilding,
  FaCheckCircle,
  FaChevronLeft,
  FaChevronRight,
  FaHandshake,
  FaHardHat,
  FaLeaf,
  FaShieldAlt,
  FaTools,
  FaUsers,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

export default function AboutUs() {
  const [ready, setReady] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: banner1,
      title: "Powering Tanzania's Infrastructure",
      subtitle: "Engineering excellence for a brighter future",
    },
    {
      image: pageHero,
      title: "Electrical & Civil Engineering Solutions",
      subtitle: "Delivering quality projects across East Africa",
    },
    {
      image: banner3,
      title: "Sustainable Energy Systems",
      subtitle: "Innovation in renewable energy and construction",
    },
  ];

  useEffect(() => {
    AOS.init({ once: false, offset: 120, easing: "ease-in-out", duration: 750 });
    setReady(true);

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  const values = [
    {
      icon: <FaShieldAlt />,
      title: "Safety First",
      text: "We prioritize rigorous safety standards and compliance in every project we undertake.",
      color: "#3B82F6",
    },
    {
      icon: <FaCheckCircle />,
      title: "Quality Excellence",
      text: "Delivering engineering solutions that meet international standards and client expectations.",
      color: "#10B981",
    },
    {
      icon: <FaHandshake />,
      title: "Integrity",
      text: "Transparent communication, ethical practices, and accountability in all our engagements.",
      color: "#8B5CF6",
    },
    {
      icon: <FaUsers />,
      title: "Community Impact",
      text: "Empowering Tanzania's infrastructure growth through sustainable engineering solutions.",
      color: "#F59E0B",
    },
  ];

  const coreServices = [
    {
      category: "Electrical Engineering",
      icon: <FaBolt />,
      color: "from-yellow-400 to-orange-500",
      services: [
        "LV & HV Installation",
        "Electrical Machines Installation & Maintenance",
        "Testing & Commissioning",
        "Solar & Renewable Energy Systems",
      ],
    },
    {
      category: "Civil Engineering",
      icon: <FaBuilding />,
      color: "from-blue-400 to-blue-600",
      services: [
        "Civil & Building Services",
        "Transmission Lines Construction",
        "Roads & Bridges Construction",
        "Sub-Station Foundations",
      ],
    },
    {
      category: "General Engineering",
      icon: <FaTools />,
      color: "from-emerald-400 to-teal-600",
      services: [
        "Project Management & Consultancy",
        "Manpower Supply",
        "Planning & Scheduling",
        "Root Cause Analysis",
      ],
    },
  ];

  const projectHighlights = [
    {
      client: "Songas Limited",
      year: "2025",
      scope: "Gas pipeline soil erosion protection & rust control",
    },
    {
      client: "KILI Steel Limited",
      year: "2025",
      scope: "HT line tapping, transformer installation & metering",
    },
    {
      client: "DIT",
      year: "2025",
      scope: "33kV high tension power line & 1000kVA transformer",
    },
    {
      client: "REA",
      year: "2020",
      scope: "100KM MV lines, 135KM LV networks across 32 villages",
    },
  ];

  return (
    <>
      {/* Modern Hero Slider */}
      <div className="MainBodySection position-relative overflow-hidden" style={{ minHeight: "90vh" }}>
        {/* Slider Container */}
        <div className="position-relative" style={{ height: "90vh" }}>
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`position-absolute w-100 h-100 transition-all duration-1000 ${
                index === currentSlide ? "opacity-100 visible" : "opacity-0 invisible"
              }`}
              style={{
                transition: "opacity 1s ease-in-out, transform 1s ease-in-out",
                transform: index === currentSlide ? "scale(1)" : "scale(1.05)",
              }}
            >
              {/* Background Image with Overlay */}
              <div
                className="position-absolute w-100 h-100"
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                <div className="position-absolute w-100 h-100" style={{
                  background: "linear-gradient(135deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 58, 138, 0.8) 50%, rgba(15, 23, 42, 0.85) 100%)"
                }} />
              </div>

              {/* Content */}
              <div className="container position-relative h-100">
                <div className="row h-100 align-items-center">
                  <div className="col-lg-8" data-aos="fade-up" data-aos-delay="300">
                    <div className="text-white">
                      <h1 className="display-3 fw-bold mb-4" style={{ lineHeight: 1.1, fontSize: "clamp(2.5rem, 5vw, 4.5rem)" }}>
                        {slide.title}
                      </h1>
                      <p className="lead mb-5 opacity-90" style={{ fontSize: "1.25rem", maxWidth: "650px" }}>
                        {slide.subtitle}
                      </p>
                      <div className="d-flex gap-3 flex-wrap">
                        <button className="btn btn-primary btn-lg px-5 py-3 rounded-pill fw-semibold" style={{ backgroundColor: "#3B82F6", border: "none" }}>
                          Our Projects
                        </button>
                        <button className="btn btn-outline-light btn-lg px-5 py-3 rounded-pill fw-semibold">
                          Contact Us
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          
        </div>

        {/* Floating Info Cards */}
        <div className="container position-relative" style={{ marginTop: "-80px" }}>
          <div className="row g-4">
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="card border-0 shadow-lg h-100" style={{ borderRadius: "16px", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-primary bg-opacity-10 p-3 rounded-circle me-3">
                      <FaBolt className="text-primary fs-4" />
                    </div>
                    <div>
                      <h5 className="mb-0 fw-bold">Licensed Experts</h5>
                      <small className="text-muted">CRB & TANESCO Certified</small>
                    </div>
                  </div>
                  <p className="mb-0 text-muted">Fully licensed electrical contractor with proven expertise in HV/LV systems.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 shadow-lg h-100" style={{ borderRadius: "16px", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-success bg-opacity-10 p-3 rounded-circle me-3">
                      <FaCheckCircle className="text-success fs-4" />
                    </div>
                    <div>
                      <h5 className="mb-0 fw-bold">6+ Years Experience</h5>
                      <small className="text-muted">Since 2019</small>
                    </div>
                  </div>
                  <p className="mb-0 text-muted">Successfully delivered 12+ major projects across Tanzania.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
              <div className="card border-0 shadow-lg h-100" style={{ borderRadius: "16px", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <div className="bg-warning bg-opacity-10 p-3 rounded-circle me-3">
                      <FaUsers className="text-warning fs-4" />
                    </div>
                    <div>
                      <h5 className="mb-0 fw-bold">Expert Team</h5>
                      <small className="text-muted">Certified Engineers</small>
                    </div>
                  </div>
                  <p className="mb-0 text-muted">Team of 7+ certified engineers and technicians with 8-10 years experience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Who We Are - Modern Layout */}
      <div className="MainBodySection py-5 my-5">
        <div className="container px-3">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="position-relative">
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-primary rounded-4" style={{ transform: "translate(-20px, 20px)", opacity: 0.1 }} />
                <img src={banner3} alt="MGE Project" className="img-fluid rounded-4 shadow-lg position-relative" style={{ zIndex: 1 }} />
                <div className="position-absolute bottom-0 end-0 bg-white p-4 rounded-4 shadow-lg m-4" style={{ zIndex: 2 }}>
                  <div className="d-flex align-items-center">
                    <div className="bg-primary text-white rounded-circle p-3 me-3">
                      <FaHardHat className="fs-3" />
                    </div>
                    <div>
                      <h4 className="mb-0 fw-bold">12+</h4>
                      <small className="text-muted">Projects Completed</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <h2 className="display-5 font-bold mb-4 text-primary">Engineering Excellence Since 2019</h2>
              <p className="lead text-muted mb-4">
                Medal Global Engineering Ltd. is a registered Tanzanian company specializing in electrical engineering, civil construction, and maintenance services.
              </p>
              <p className="text-muted mb-4">
                We combine technical expertise with local knowledge to deliver infrastructure solutions that stand the test of time. Our team of certified engineers ensures every project meets stringent quality, safety, and regulatory standards.
              </p>
              <div className="row g-3">
                <div className="col-6">
                  <div className="d-flex align-items-start">
                    <FaCheckCircle className="text-primary mt-1 me-2" />
                    <div>
                      <h6 className="fw-bold mb-1">CRB Certified</h6>
                      <small className="text-muted">Electrical & Civil</small>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-start">
                    <FaCheckCircle className="text-primary mt-1 me-2" />
                    <div>
                      <h6 className="fw-bold mb-1">TANESCO Licensed</h6>
                      <small className="text-muted">Contractor & Supply</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mission & Vision - Cards */}
      <div className="MainBodySection py-5" style={{ background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)" }}>
        <div className="container px-3">
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <div className="card border-0 h-100" style={{ borderRadius: "20px", background: "white", boxShadow: "0 10px 40px rgba(0,0,0,0.1)" }}>
                <div className="card-body p-5">
                  <div className="bg-primary bg-opacity-10 d-inline-flex p-3 rounded-circle mb-4">
                    <FaBolt className="text-light fs-2" />
                  </div>
                  <h3 className="fw-bold mb-3">Our Mission</h3>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.8 }}>
                    To deliver high-quality engineering solutions that support infrastructure growth and business empowerment across Tanzania.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
              <div className="card border-0 h-100" style={{ borderRadius: "20px", background: "white", boxShadow: "0 10px 40px rgba(0,0,0,0.1)" }}>
                <div className="card-body p-5">
                  <div className="bg-success bg-opacity-10 d-inline-flex p-3 rounded-circle mb-4">
                    <FaLeaf className="text-success fs-2" />
                  </div>
                  <h3 className="fw-bold mb-3">Our Vision</h3>
                  <p className="text-muted mb-0" style={{ lineHeight: 1.8 }}>
                    To be a leading engineering solutions provider across Tanzania and East Africa, recognized for excellence, innovation, and sustainable impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Core Services - Modern Grid */}
      <div className="MainBodySection py-5 my-5">
        <div className="container px-3">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="display-5 font-bold text-secondary mb-3">Comprehensive Engineering Services</h2>
            <p className="lead text-muted" style={{ maxWidth: "600px", margin: "0 auto" }}>
              From concept to commissioning, we provide integrated solutions across electrical, civil, and renewable energy domains.
            </p>
          </div>

          <div className="row g-4">
            {coreServices.map((service, index) => (
              <div key={service.category} className="col-lg-4" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="card border-0 h-100" style={{ borderRadius: "20px", overflow: "hidden", boxShadow: "0 10px 40px rgba(0,0,0,0.08)", transition: "transform 0.3s ease" }}>
                  <div className={`card-header bg-gradient ${service.color} border-0 p-4`}>
                    <div className="text-white">
                      <div className="fs-1 mb-2">{service.icon}</div>
                      <h4 className="fw-bold mb-0">{service.category}</h4>
                    </div>
                  </div>
                  <div className="card-body p-4">
                    <ul className="list-unstyled mb-0">
                      {service.services.map((item, i) => (
                        <li key={i} className="d-flex align-items-center mb-3">
                          <FaCheckCircle className="text-success me-3" />
                          <span className="text-muted">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Core Values - Icon Grid */}
      <div className="MainBodySection py-5" style={{ background: "#0f172a" }}>
        <div className="container px-3">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="display-5 font-bold text-secondary mb-3">What Guides Our Work</h2>
            <p className="lead text-white-50" style={{ maxWidth: "600px", margin: "0 auto" }}>
              Every project reflects our commitment to safety, quality, integrity, and sustainable development.
            </p>
          </div>

          <div className="row g-4">
            {values.map((value, index) => (
              <div key={value.title} className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="text-center p-4 rounded-4 h-100" style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)" }}>
                  <div className="d-inline-flex p-3 rounded-circle mb-3" style={{ background: `${value.color}20` }}>
                    <div style={{ color: value.color, fontSize: "2rem" }}>{value.icon}</div>
                  </div>
                  <h4 className="fw-bold text-white mb-3">{value.title}</h4>
                  <p className="text-white-50 mb-0" style={{ lineHeight: 1.7 }}>{value.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Project Highlights - Timeline Style */}
      <div className="MainBodySection py-5 my-5">
        <div className="container px-3">
          <div className="text-center mb-5" data-aos="fade-up">
            <h2 className="display-5 fw-bold mb-3">Recent Project Highlights</h2>
            <p className="lead text-muted" style={{ maxWidth: "600px", margin: "0 auto" }}>
              Over the past six years, we've successfully delivered complex engineering projects for leading organizations.
            </p>
          </div>

          <div className="row g-4">
            {projectHighlights.map((project, index) => (
              <div key={`${project.client}-${project.year}`} className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="card border-0 h-100" style={{ borderRadius: "16px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", transition: "transform 0.3s ease" }}>
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="bg-primary bg-opacity-10 text-primary px-3 py-1 rounded-pill fw-semibold" style={{ fontSize: "0.85rem" }}>
                        {project.year}
                      </div>
                    </div>
                    <h5 className="fw-bold mb-2">{project.client}</h5>
                    <p className="text-muted mb-0 small" style={{ lineHeight: 1.6 }}>{project.scope}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Compliance Section */}
      <div className="MainBodySection py-5 bg-primary">
        <div className="container px-3 text-center">
          <div data-aos="fade-up">
            <h3 className="display-6 fw-bold text-white mb-3">Fully Licensed & Compliant</h3>
            <p className="lead text-white-50 mb-5" style={{ maxWidth: "650px", margin: "0 auto" }}>
              Medal Global Engineering holds all required certifications for electrical and civil engineering works in Tanzania.
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              {["CRB Certified", "TANESCO Licensed", "Electrical Contractor", "VAT Registered", "TIN Certified"].map((badge, i) => (
                <div key={i} className="bg-white bg-opacity-10 backdrop-blur px-4 py-3 rounded-3 text-white d-flex align-items-center">
                  <FaCheckCircle className="me-2" /> {badge}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </>
  );
}